import {GlobalAnalyticsVariablesInterface, TrackPrintSspInterface} from '../interfaces';
import {analyticsConstants, constants} from '../../constants';

import {TrackingUtilsService} from './tracking-utils.service';
import {AnalyticsService} from '../../modules/core/services/analytics.services';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackPrintSspPayloadCase = (
  payload: any,
  analyticsService: AnalyticsService,
  trackingUtilsService: TrackingUtilsService,
  globalVariables: GlobalAnalyticsVariablesInterface,
): TrackPrintSspInterface => {
  const { analyticsData, bookingId, boardingPassId, stateRoom } = retrieveValuesFromServices(analyticsService, trackingUtilsService);

  const data = {
    eventType: analyticsConstants.INTERACTION_EVENT_TYPE,
    interaction: 'setSailPrinted',
    olciPassengerIds: payload ? `${payload}` : constants.DEFAULT_GUEST_ID_FOR_TRACKING.ID,
    bookingId,
    boardingPassId,
    stateRoom,
    vdsId: analyticsData?.vdsId,
    passengerId: analyticsData?.paxid,
    shipCode: analyticsData?.shipCode,
    voyageId: analyticsData?.voyageId,
    country: analyticsData?.country,
    language: analyticsData?.language,
    previousPageName: analyticsData?.previousPage,
    userType: analyticsData?.userType,
    bookingDesc: analyticsData?.bookingDesc,
    bookingStatus: analyticsData?.bookingStatus,
    channel: analyticsData?.channel,
    siteType: analyticsData?.siteType,
    scode_version: analyticsData?.scode_version,
    brand: analyticsData?.brandID
  };
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
}

const retrieveValuesFromServices = (
  analyticsService: AnalyticsService,
  trackingUtilsService: TrackingUtilsService
) => {
  const analyticsData = analyticsService.getAnalyticsDataForTracking(constants.APP_STORE_SOURCE_PAGE.MOBILE_AD_MODAL, constants.ANALYTICS_LOCATIONS.BOARDING_PASS);
  const bookingId = trackingUtilsService.getGuestData().bookingId;
  const boardingPassId = trackingUtilsService.getSspBarCode();
  const stateRoom = trackingUtilsService.getSspStateRoom();

  return { analyticsData, bookingId, boardingPassId, stateRoom };
}
